export const routes = {
  access: 'access',
  accessRequests: 'access-requests',
  activity: 'activity',
  allocation: 'allocation',
  add: 'add',
  admin: 'admin',
  all: 'all',
  allocate: 'allocate',
  detail: 'detail',
  answers: 'answers',
  approvals: 'approvals',
  authenticate: 'authenticate',
  audiences: 'audiences',
  badges: 'badges',
  communicationCampaigns: 'communication-campaigns',
  companies: 'companies',
  create: 'create',
  edit: 'edit',
  customInfo: 'custom-info',
  emailConfirmation: 'email-confirmation',
  event: 'event',
  events: 'events',
  error: 'error',
  filters: 'filters',
  distribution: 'distribution',
  fanGroupConfiguration: 'fan-group-configuration',
  fanGroups: 'fan-groups',
  fans: 'fans',
  fanWebApp: 'fan-web-app',
  filterConfig: 'filter-config',
  general: 'general',
  guestlist: 'guestlist',
  // Smart Invites. Every value in `routes` is a reserved top-level segment (a route always beats a
  // fan-group slug); `join` is the share-link landing, mounted under the fan waiting-lists area.
  guests: 'guests',
  hostCuration: 'host-curation',
  insights: 'insights',
  interests: 'interests',
  invites: 'invites',
  join: 'join',
  landing: 'landing',
  // Smart Invites governance rules: the audience admin's Limitations tab.
  limitations: 'limitations',
  experienceGroups: 'experience-groups',
  login: 'sign-in',
  memberOutOfList: 'member-out-of-list',
  // Smart Invites: the Host's conversations with their Guests and the Fan Group Owner.
  messages: 'messages',
  myWaitingLists: 'my-waiting-lists',
  notifications: 'notifications',
  paymentSystems: 'payment-systems',
  personalInfo: 'personal-info',
  personalization: 'personalization',
  privacy: 'privacy',
  profile: 'settings',
  profiling: 'profiling',
  protectionCodes: 'protection-codes',
  publish: 'publish',
  questionnaires: 'questionnaires',
  reporting: 'reporting',
  requests: 'requests',
  // PROTOTYPE: FG compliance & spend aggregate (invite-management thread A)
  compliance: 'compliance',
  resetPassword: 'reset-password',
  root: '/',
  // PROTOTYPE: assigned-seating setup step
  seating: 'seating',
  security: 'security',
  sessions: 'sessions',
  settings: 'settings',
  signup: 'sign-up',
  surveys: 'surveys',
  surveyAfterEvent: 'survey-after-event',
  supportActions: 'support-actions',
  translations: 'translations',
  ticketingSystems: 'ticketing-systems',
  tickets: 'tickets',
  updatePassword: 'forgot-password',
  usage: 'usage',
  users: 'users',
  venues: 'venues',
  verify: 'verify',
  waitingList: 'waitinglist',
  waitingLists: 'waiting-lists',
  wishLists: 'wish-lists',
  wls: 'wls',
  draft: 'draft',
  sent: 'sent',
  scheduled: 'scheduled',
  experiences: 'experiences',
  dashboard: 'dashboard',
  mail: 'mail',
  sms: 'sms',
  whatsapp: 'whatsapp',

  themes: 'themes',
  theme: 'theme',
  templates: 'templates',
  preview: 'preview',
  bulkOperations: 'bulk-operations',

  communication: 'communication',
  communications: 'communications',
  transactional: 'transactional',
  defaultCommunications: 'default-communications',
  types: 'types',

  // company admin routes
  companySettings: 'company-settings',
  admins: 'admins',
  billing: 'billing',
  companyAudiences: 'audiences',
  tags: 'tags',

  // ticket scanner (prototype)
  scan: 'scan',

  // custom slug
  portofantwerpemployees: 'portofantwerpemployees',
};
